<template>
<div>
	<div v-if="isShowFull" class="wrap-image-full">
		<div class="backdrop"></div>
		<div class="wrap-image" @click="switcher">
			<img v-bind="imgProp" width="auto" height="auto">
		</div>
	</div>
	<img v-bind="imgProp" @click="switcher">
</div>
</template>
<script>
export default {
	data: () => ({
		isShowFull: false
	}),
	props: {
		imgProp: Object
	},
	methods: {
		switcher() {
			this.isShowFull = !this.isShowFull
		}
	}
}
</script>

<style scoped>
.wrap-image-full {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 1000;
	cursor: pointer;
}

.backdrop {
	position: fixed;
	width: 100%;
	height: 100%;
	background: black;
	opacity: 0.5;
}

.wrap-image {
	position: relative;
	z-index: 1001;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}

.wrap-image > img {
	max-width: 100%;
	max-height: 100%;
}

img {
	cursor: pointer;
}
</style>
